import {
  type CreatePolicyInput,
  CreateBackupPolicyApi,
  DeleteBackupPolicyApi,
  ListBackupPoliciesApi,
  type BackupPolicyConfig,
  type Configuration,
  UpdateBackupPolicyApi,
} from '@repo/api-gw-sdk';
import type { SWRConfiguration } from 'swr';

import type { HttpClient } from './httpClient';

const basesUrl = '/backup-policies';

export const backupPolicy = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const listPoliciesApi = new ListBackupPoliciesApi(config);
  const createApi = new CreateBackupPolicyApi(config);
  const editApi = new UpdateBackupPolicyApi(config);
  const deleteApi = new DeleteBackupPolicyApi(config);
  return {
    useList: (
      pageIndex?: number,
      pageSize?: number,
      options?: SWRConfiguration
    ) =>
      httpClient.executeWithConfig(
        listPoliciesApi.listPolicies.bind(listPoliciesApi),
        basesUrl,
        '',
        options,
        currentProjectId,
        pageIndex,
        pageSize
      ),
    create: (policy: CreatePolicyInput) =>
      createApi.createPolicy(currentProjectId, policy),
    update: (policy: BackupPolicyConfig) =>
      editApi.updatePolicy(currentProjectId, policy.id, policy),
    delete: (policyId: string) =>
      deleteApi.deletePolicy(currentProjectId, policyId),
  };
};
